/*
=========================================================
* RingFoods Final CTA Section - "Imagine Tomorrow Morning"
=========================================================
*/

// @mui material components
import Container from "@mui/material/Container";
import Grid from "@mui/material/Grid";
import Stack from "@mui/material/Stack";

// @mui icons
import PlayCircleOutlineIcon from "@mui/icons-material/PlayCircleOutline";

// Material Kit 2 PRO React components
import MKBox from "components/MKBox";
import MKButton from "components/MKButton";
import MKTypography from "components/MKTypography";

import { accentSuccess, brandPrimary } from "pages/RingFoodsHomepage/theme";
import useSignupUrl from "hooks/useSignupUrl";
import { getDisplayTrialDays } from "constants/promo";

function FinalCTA() {
  const signupUrl = useSignupUrl();
  return (
    <MKBox
      component="section"
      py={{ xs: 8, md: 12 }}
      sx={{
        backgroundImage: {
          xs: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(https://images.unsplash.com/photo-1552566626-52f8b828add9?w=600&q=50&fm=webp)`,
          md: `linear-gradient(rgba(0, 0, 0, 0.8), rgba(0, 0, 0, 0.8)), url(https://images.unsplash.com/photo-1552566626-52f8b828add9?w=1200&q=60&fm=webp)`,
        },
        backgroundSize: "cover",
        backgroundPosition: "center",
        backgroundAttachment: { md: "fixed", xs: "scroll" },
      }}
    >
      <Container>
        <Grid container justifyContent="center">
          <Grid item xs={12} md={10} lg={8} textAlign="center">
            {/* Headline */}
            <MKTypography
              variant="h2"
              color="white"
              fontWeight="bold"
              sx={{ mb: 3, fontSize: { xs: "2rem", sm: "2.5rem", md: "3rem" } }}
            >
              Imagine Tomorrow Morning
            </MKTypography>

            {/* Narrative Body */}
            <MKTypography
              variant="body1"
              color="white"
              sx={{
                fontSize: { xs: "1.05rem", md: "1.2rem" },
                lineHeight: 1.9,
                opacity: 0.9,
                mb: 2,
              }}
            >
              You walk in and check the dashboard. Fourteen calls came in overnight &mdash; every
              single one answered. Three reservations booked for the weekend. A Mandarin-speaking
              family reserved a table for six. A complaint about last week&apos;s order was handled
              with empathy and flagged for your review. Nobody on your team touched the phone.
            </MKTypography>

            <MKTypography
              variant="body1"
              color="white"
              sx={{
                fontSize: { xs: "1.05rem", md: "1.2rem" },
                lineHeight: 1.9,
                opacity: 0.85,
                mb: 5,
                fontStyle: "italic",
              }}
            >
              That&apos;s what 30 minutes of setup gets you.
            </MKTypography>

            {/* CTA Buttons */}
            <Stack direction={{ xs: "column", sm: "row" }} spacing={2} justifyContent="center" sx={{ mb: 3 }}>
              <MKButton
                size="large"
                variant="contained"
                onClick={() => window.location.href = signupUrl}
                sx={{
                  backgroundColor: "#FFFFFF !important",
                  color: "#1A1A1A !important",
                  px: { xs: 4, md: 5 },
                  py: { xs: 1.5, md: 1.75 },
                  fontSize: { xs: "1.05rem", md: "1.15rem" },
                  fontWeight: 700,
                  borderRadius: 2,
                  cursor: "pointer",
                  "&:hover": {
                    backgroundColor: "#F5F5F5 !important",
                    transform: "translateY(-2px)",
                    boxShadow: "0 10px 25px rgba(0,0,0,0.3)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                Start Your Free Trial
              </MKButton>

              <MKButton
                size="large"
                variant="outlined"
                startIcon={<PlayCircleOutlineIcon />}
                component="a"
                href="/demo.html"
                sx={{
                  borderColor: "#FFFFFF !important",
                  color: "#FFFFFF !important",
                  px: { xs: 4, md: 5 },
                  py: { xs: 1.5, md: 1.75 },
                  fontSize: { xs: "1.05rem", md: "1.15rem" },
                  fontWeight: 600,
                  borderRadius: 2,
                  "&:hover": {
                    borderColor: "#FFFFFF !important",
                    backgroundColor: "rgba(255, 255, 255, 0.1)",
                    transform: "translateY(-2px)",
                  },
                  transition: "all 0.3s ease",
                }}
              >
                View Demo
              </MKButton>
            </Stack>

            {/* Bottom Note */}
            <MKTypography variant="body2" color="white" sx={{ opacity: 0.7 }}>
              30 minutes to set up. {getDisplayTrialDays()} days free. You won&apos;t be charged
              until your trial ends.
            </MKTypography>
          </Grid>
        </Grid>
      </Container>
    </MKBox>
  );
}

export default FinalCTA;
